import { CurrencyPipe } from '@angular/common';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AmountFormatterService {
  constructor(private currencyPipe: CurrencyPipe) {}

  public formattedAmount(amount: string | number, withSymbol: boolean = false) {
    const symbol = withSymbol ? 'symbol' : '';
    return this.currencyPipe.transform(amount, 'USD', symbol, '1.2-2');
  }

  public sanitizePrice(price: string): number {
    if (!price) { return; }
    const priceString = price.toString();
    return +(priceString.replace(/^\$|,/g, ''));
  }

}
